module.exports = __webpack_public_path__ + "aeaa20109146fceecad1658958c22312.pdf";